import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    school: { Success: false, Data: { Count: 0 } },
    status: 'idle',
    getTeacherStatus: 'idle',
    error: null,
    teachersInSchool: { Success: false, Data: [] },
};

export const addNetworkInvitees = createAsyncThunk(
    'school/addNetworkInvitees',
    async data => {
        const response = await axios.post('/sendNetworkRequest', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: '/sendNetworkRequest',
            timeout: 30000,
            headers: {
                Authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

export const fetchSchool = createAsyncThunk('user/getMySchool', async data => {
    console.log('hit the fetch school from school slice');
    const response = await axios.get('/getMySchool', {
        baseURL: process.env.REACT_APP_API_GATEWAY,
        timeout: 30000,
        headers: {
            authorization: `Bearer ${data.token}`,
            'Content-Type': 'application/json',
        },
        params: {
            schoolId: data.schoolId,
        },
    });
    return response.data;
});

export const getSchoolTeachers = createAsyncThunk(
    'user/getSchoolTeachers',
    async data => {
        const response = await axios.get('/getSchoolTeachers?type=verified', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/getSchoolTeachers`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

export const updateSchool = createAsyncThunk(
    'school/updateSchoolInfo',
    async data => {
        const response = await axios.post(
            '/updateSchoolProfile',
            data.request,
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: `/updateSchoolProfile`,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${data.token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    }
);

export const addNetworkToSchool = createAsyncThunk(
    'school/addNetworkToSchool',
    async data => {
        const response = await axios.post('/addSchoolNetwork', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/addSchoolNetwork`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

export const addPayUser = createAsyncThunk(
    'school/updatePayUser',
    async data => {
        const response = await axios.get('/getPayUser', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

export const addSubscription = createAsyncThunk(
    'school/createSchoolSubscription',
    async data => {
        const response = await axios.post(
            '/createSchoolSubscription',
            { 'type': data.request },
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${data.token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    }
);

export const addCrtToList = createAsyncThunk(
    'school/addCrtToList',
    async data => {
        const response = await axios.post('/addCrtToList', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${data.token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);

export const removeCrtToList = createAsyncThunk(
    'school/removeCrtToList',
    async data => {
        console.log('removeCrtToListdata', data);
        const response = await axios.delete(
            `${process.env.REACT_APP_API_GATEWAY}/removeCrtToList`,
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: '/removeCrtToList',
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${data.token}`,
                    'Content-Type': 'application/json',
                },
                data: data.request,
            }
        );

        return response.data;
    }
);

export const removeSubscription = createAsyncThunk(
    'school/removeSchoolSubscription',
    async data => {
        const response = await axios.delete(
            '/removeSchoolSubscription',
            { 'type': data.request },
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${data.token}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    }
);
// need to obtain token silently before the API call and remove from availability page

const schoolSlice = createSlice({
    name: 'school',
    initialState,
    reducers: {
        searchAdded(state, action) {
            const {
                pk1,
                sk1,
                gs1pk,
                mainContact,
                emailList,
                profileImage,
                address,
                lat,
                lng,
            } = action.payload;
            const currentSchool = state.search;
            if (currentSchool) {
                currentSchool.pk1 = pk1;
                currentSchool.sk1 = sk1;
                currentSchool.gs1pk = gs1pk;
                currentSchool.mainContact = mainContact;
                currentSchool.emailList = emailList;
                currentSchool.profileImage = profileImage;
                currentSchool.address = address;
                currentSchool.lat = lat;
                currentSchool.lng = lng;
            }
        },
    },
    extraReducers: {
        [addNetworkInvitees.rejected]: (state, action) => {
            console.log('networkAddFailed');
        },
        [addNetworkInvitees.fulfilled]: (state, action) => {
            // add the new invitee list to the school profile
            const interimSchool = state.school;
            const updatedItems = action.payload.Message.Data.updated;
            const newCrtList = interimSchool.Data.crtList.map(savedCRT => {
                if (
                    updatedItems.some(
                        updated => updated.value.uniqueId === savedCRT.uniqueId
                    )
                ) {
                    let newCrtObj = savedCRT;
                    newCrtObj.networkInvitation = updatedItems.find(
                        updated => updated.value.uniqueId === savedCRT.uniqueId
                    ).value.status;
                    return newCrtObj;
                } else {
                    return savedCRT;
                }
            });
            console.log('New CRT lists ' + JSON.stringify(newCrtList));
            let networkItems =
                interimSchool.Data.networkDetails.networkItems === undefined
                    ? []
                    : interimSchool.Data.networkDetails.networkItems;
            console.log('networkItems ' + JSON.stringify(networkItems));
            updatedItems.map(updated => {
                networkItems.push(updated.value);
            });
            console.log(
                'interimSchool.Data.networkDetails.networkItem',
                interimSchool.Data.networkDetails.networkItem
            );
            interimSchool.Data.crtList = newCrtList;
            interimSchool.Data.networkDetails.networkItems = networkItems;
            state.school = interimSchool;
        },
        [fetchSchool.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchSchool.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            console.log(
                'Fetch School: Need to format date into this ' +
                    JSON.stringify(action.payload.Message.Data)
            );
            state.school.Data = action.payload.Message.Data;
        },
        [getSchoolTeachers.pending]: (state, action) => {
            state.getTeacherStatus = 'loading';
        },
        [getSchoolTeachers.rejected]: (state, action) => {
            state.getTeacherStatus = 'failed';
        },
        [getSchoolTeachers.fulfilled]: (state, action) => {
            state.getTeacherStatus = 'succeeded';
            state.teachersInSchool.Data = action.payload.Message.Data;
        },
        [addPayUser.fulfilled]: (state, action) => {
            let interimSchool = state.school;
            interimSchool.Data.paymentCustomerId =
                action.payload.Attributes.paymentCustomerId.S;
            state.school.Data = interimSchool.Data;
        },
        [updateSchool.pending]: (state, action) => {
            state.status = 'loading';
        },
        [updateSchool.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            console.log(
                'Update School: Need to format date into this ' +
                    JSON.stringify(action.payload.Message.Data)
            );
            state.school.Data = action.payload.Message.Data;
        },
        [addNetworkToSchool.fulfilled]: (state, action) => {
            let interimSchool = state.school;
            interimSchool.Data.networkDetails.network =
                action.payload.Message.Data;
            state.school.Data = interimSchool.Data;
        },
        [addNetworkToSchool.rejected]: (state, action) => {
            console.log(
                'Failed to add network' + JSON.stringify(action.payload)
            );
        },
        [addSubscription.fulfilled]: (state, action) => {
            // Add any fetched posts to the array
            console.log(
                'Add Subscription: Need to format date into this ' +
                    JSON.stringify(action.payload.Message.Data)
            );

            state.school.Data = action.payload.Message.Data.school;
        },
        [addSubscription.rejected]: (state, action) => {
            // Add any fetched posts to the array
            console.log(
                'Failed to add subscription ' + JSON.stringify(action.payload)
            );
        },
        [addCrtToList.fulfilled]: (state, action) => {
            // Add any fetched posts to the array
            console.log(
                'Add Current To List: Need to format date into this ' +
                    JSON.stringify(action.payload.Success)
            );

            state.school.Data.crtList.push(action.payload.Message.Data);
        },
        [removeCrtToList.rejected]: (state, action) => {
            // Add any fetched posts to the array
            console.log('removeCrtList ' + JSON.stringify(action));
        },
        [removeCrtToList.fulfilled]: (state, action) => {
            // Add any fetched posts to the array
            console.log('removeCrtList ' + JSON.stringify(action));
            state.school.Data.crtList = state.school.Data.crtList.filter(
                item => item.uniqueId !== action.payload.Message.Data.uniqueId
            );
        },
        [removeSubscription.fulfilled]: (state, action) => {
            // Add any fetched posts to the array
            console.log(
                'Remove Subscription: Need to format date into this ' +
                    JSON.stringify(action.payload.Message.Data)
            );

            state.school.Data = action.payload.Message.Data;
        },
    },
});

export const { schoolAdded } = schoolSlice.actions;

export default schoolSlice.reducer;

export const getSchool = state => state.school;
